import React from 'react';
import Gallery from '../components/Gallery';
import AdminContext from '../lib/AdminContext';

export default function AlbumPreview({entry}) {
  return (
    <AdminContext.Provider value={true}>
      <h1>{entry.getIn(['data', 'title'])}</h1>
      <Gallery album={{photos: entry.getIn(['data', 'photos']).toJS()}} columns={4} />
    </AdminContext.Provider>
  );
}
